/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Invite_SendInputs */

const es_admin_users_invite_send = /** @type {(inputs: Admin_Users_Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar invitación`)
};

const en_admin_users_invite_send = /** @type {(inputs: Admin_Users_Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send invitation`)
};

/**
* | output |
* | --- |
* | "Send invitation" |
*
* @param {Admin_Users_Invite_SendInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_invite_send = /** @type {((inputs?: Admin_Users_Invite_SendInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Invite_SendInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_invite_send(inputs)
	return en_admin_users_invite_send(inputs)
});
export { admin_users_invite_send as "admin.users.invite.send" }